export default function setupAddressAutocomplete(prefix, apiKey) {
  var allFields = [
    { element: `${prefix}street_address_line_1`,  field: "Line1"         ,  mode: pca.fieldMode.DEFAULT },
    { element: `${prefix}street_address_line_2`,  field: "Line2"         ,  mode: pca.fieldMode.POPULATE },

    { element: `${prefix}street_number`        ,  field: "BuildingNumber",  mode: pca.fieldMode.POPULATE }, // Street Number
    { element: `${prefix}apartment`            ,  field: "SubBuilding"   ,  mode: pca.fieldMode.POPULATE }, // Unit Number
    { element: `${prefix}street_name`          ,  field: "Street"        ,  mode: pca.fieldMode.POPULATE },
    { element: `${prefix}department`           ,  field: "Department"    ,  mode: pca.fieldMode.POPULATE },

    { element: `${prefix}city`                 ,  field: "City"          ,  mode: pca.fieldMode.POPULATE },
    { element: `${prefix}province`             ,  field: "ProvinceName"  ,  mode: pca.fieldMode.POPULATE },
    { element: `${prefix}postal_code`          ,  field: "PostalCode"    ,  mode: pca.fieldMode.POPULATE },
    { element: `${prefix}country`              ,  field: "CountryName"   ,  mode: pca.fieldMode.COUNTRY  }
  ];

  // Filter out fields that don't exist in the DOM
  var fields = allFields.filter(function (field) {
    var elementExists;
    var element = document.querySelector(`#${field.element}`);

    if (element !== null) {
      elementExists = true;
    } else {
      console.warn(
        `Field "${field.field}" with ID "${field.element}" does not exist. ` +
        `This may be intentional for this page, but please confirm if that is the case.`
      );

      elementExists = false;
    }

    return elementExists;
  });

  // Avoid initializing if no valid fields exist
  if (fields.length === 0) return;

  var options = {
    key: apiKey
  };

  var control = new pca.Address(fields, options);

  if (!control) return; // Prevent errors if initialization fails

  // Re-trigger change event for select2 to properly show the autofilled value in it's dropdown field
  control.listen("populate", function (address) {
    setTimeout(() => {
      let provinceElement = document.querySelector(`#${prefix}province`);
      if (provinceElement) {
        provinceElement.dispatchEvent(new Event("change"));
      }
    }, 100);
  });
};
